import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import {
  IWarehouserRequest,
  IWarehouserResponse,
} from '../../models/user/warehouser.model';
import useHttps from '../useHttps';

const useWarehouser = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const oncreateWarehouserError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const oncreateWarehouserSuccess = ({
    message,
  }: SuccessHttpResponse<IWarehouserResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const createWarehouser = (data: IWarehouserRequest) => {
    const url: HttpConfig = {
      url: 'authentication-service/v1/warehouse/users',
      method: 'post',
      data,
    };

    request(
      url,
      oncreateWarehouserSuccess,
      setLoading,
      oncreateWarehouserError
    );
  };

  return { createWarehouser, loading, resetInputFields };
};

export default useWarehouser;
